/*
 * File: ContactTab.tsx
 * Project: a-a
 * File Created: Wednesday, 8th January 2025 11:05:06 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 23rd July 2025 2:39:50 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import ContactCard from './ContactCard';
import ContactDetail from './ContactDetail';
import { ClientService } from '../../../../service/client.service';
import CustomButton from '../../CustomButton/CustomButton';
import styles from './ContactTab.module.css';
const ContactTab = () => {
  const screenHeight = window.innerHeight;
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = React.useState<any>();
  const [selected, setSelected] = React.useState();
  console.log(selected);
  const getContactDetails = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res = await ClientService.getClientContacts(id);
        const contacts = res.contacts[0]?.contacts;
        console.log(res, contacts);
        if (contacts) {
          setSelected(res.contacts[0].contacts[0]);
          setDetails(res.contacts[0].contacts);
        }
      }
    } catch (err: any) {
      console.log(err, 'errdeal');
      // setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getContactDetails(params?.id || '');
    sessionStorage.removeItem('dealSelectedFromOverview');
  }, []);
  return (
    <Box sx={{}}>
      {' '}
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            gap: '20px',
            marginTop: '20px',
            height: { xs: 'calc(100vh - 370px)', xl: 'calc(100vh - 420px)' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '10px', xl: '16px' },
              flex: 1,
            }}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val) => (
              <ContactCard
                key={val}
                data={''}
                setSelected={setSelected}
                selected={selected}
                loading={loading}
              />
            ))}
          </Box>
          <Box sx={{ flex: 2, height: '100%' }}>
            {<ContactDetail selected={selected} loading={loading} />}
          </Box>
        </Box>
      ) : details?.length ? (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='responsiveHeading3'>Related Contacts</Typography>
            <Link
              to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${params?.id}/related/AccountContactRelations/view`}
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
            >
              <CustomCard
                styles={{
                  borderRadius: '50px',
                  padding: '10px 10px 10px 16px',
                  backgroundColor: zeplinColor.Neutral1,
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  display: 'flex',
                  gap: '8px',
                  // flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                }}
              >
                <Typography
                  variant='responsiveBody3'
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  Salesforce
                </Typography>
                <img src='/assets/link-2.svg' className={styles.linkIcon} />
              </CustomCard>
            </Link>
          </Box>
          <Box sx={{ display: 'flex', gap: '20px', marginTop: { xs: '10px', xl: '20px' } }}>
            <Box sx={{ flex: 1 }}>
              {' '}
              <Box
                sx={{
                  overflowY: 'scroll',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  position: 'relative',
                  height: { xs: 'calc(100vh - 370px)', xl: 'calc(100vh - 420px)' },
                  // paddingBottom: '30rem',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                {details?.length &&
                  details?.map((val: any) => (
                    <ContactCard
                      key={val?.name}
                      data={val}
                      setSelected={setSelected}
                      selected={selected}
                      loading={loading}
                    />
                  ))}
              </Box>
            </Box>
            <Box sx={{ flex: 2, height: { xs: 'calc(100vh - 370px)', xl: 'calc(100vh - 420px)' } }}>
              {<ContactDetail selected={selected} loading={loading} />}
            </Box>
          </Box>
        </>
      ) : !loading && !details?.length ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            height: 'calc(100vh - 380px)', // Match the height of your content area
            width: '100%',
            flex: 1,
            // screenHeight > 1200
            //   ? '60vh'
            //   : screenHeight > 1100
            //   ? '56vh'
            //   : screenHeight > 1000
            //   ? '53vh'
            //   : screenHeight > 900
            //   ? '47vh'
            //   : screenHeight > 800
            //   ? '41vh'
            //   : screenHeight > 700
            //   ? '34vh'
            //   : screenHeight > 600
            //   ? '20vh'
            //   : '10vh', //'40vh',
            gap: { xs: '16px', xl: '32px' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // flex: 1,
              gap: { xs: '6px', xl: '12px' },
            }}
          >
            <img src={'/assets/no-contacts.svg'} className={styles.noContactsImage} />
            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
              No Contacts Available
            </Typography>
            <Typography
              variant='responsiveBody3'
              color={zeplinColor.Neutral8}
              sx={{ textAlign: 'center' }}
            >
              Add a contact now to get started and keep <br />
              everything handy.
            </Typography>
          </Box>
          <Link
            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${params?.id}/related/AccountContactRelations/view`}
            target='_blank'
            rel='noopener noreferrer'
            style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
          >
            <CustomButton
              disabled={false}
              onClick={() => {}}
              variant='outlined'
              color='secondary'
              buttonVariant='responsiveButtonLarge'
              style={{
                // width: '40%',
                borderRadius: { xs: '10px', xl: '14px' },
                height: '48px',
                padding: { xs: '10px 12px', xl: '14px 16px' },
                backgroundColor: zeplinColor.Brand1,

                // gap: '16px',
                // padding: '14px 16px',
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Add Contacts'}
            />
          </Link>
        </Box>
      ) : (
        ''
      )}
      {/* {loading ? (
        <CustomLoader
          open={loading}
          handleCloseModal={() => {
            setLoading(false);
          }}
        />
      ) : (
        ''
      )} */}
    </Box>
  );
};

export default ContactTab;
